// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__XA83Y","ballSpinFadeLoader":"style_ballSpinFadeLoader__2GdQX","ball-spin-fade-loader":"style_ball-spin-fade-loader__OTalw"};